import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-730f375e"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "image-box"
};
const _hoisted_2 = {
  class: "image-preview"
};
const _hoisted_3 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "Current Image", -1));
const _hoisted_4 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "Upload New Image", -1));
const _hoisted_5 = {
  class: "image-side"
};
const _hoisted_6 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "Uploaded Images", -1));
const _hoisted_7 = {
  class: "image-grid"
};
const _hoisted_8 = ["onClick"];
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_b_img = _resolveComponent("b-img");
  const _component_app_upload = _resolveComponent("app-upload");
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", null, [_hoisted_3, _createVNode(_component_b_img, {
    src: $props.modelValue,
    thumbnail: "",
    alt: ""
  }, null, 8, ["src"])]), _createElementVNode("div", null, [_hoisted_4, _createVNode(_component_app_upload, {
    ref: "uploadRef",
    loading: $data.loading,
    onUpload: $options.onUpload
  }, null, 8, ["loading", "onUpload"])])]), _createElementVNode("div", _hoisted_5, [_hoisted_6, _createElementVNode("div", _hoisted_7, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.images, (image, index) => {
    return _openBlock(), _createElementBlock("div", {
      key: index,
      class: _normalizeClass(['image-item', {
        active: image == $props.modelValue
      }]),
      onClick: $event => $options.onImageClick(image)
    }, [_createVNode(_component_b_img, {
      src: image,
      thumbnail: "",
      alt: ""
    }, null, 8, ["src"])], 10, _hoisted_8);
  }), 128))])])]);
}